import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-terms-conditions',
  standalone: true,
  imports: [MatIconModule, RouterModule],
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss',
})
export class TermsConditionsComponent {
  phone: string = '';
  termsAndConditions: boolean = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    let phone = localStorage.getItem('phone');

    if (phone) {
      this.phone = phone;
    }
  }
}
